// use-modal-stack.ts — Layout/modal-stack, subscription
//
// Sync.
//

import { useModalStackContext } from './modal-stack-context';
import type { ModalStackContextValue } from './modal-stack-types';

export function useModalStack(): ModalStackContextValue {
  return useModalStackContext();
}
